import { render, staticRenderFns } from "./ListMenuChat.vue?vue&type=template&id=6eab7e01&scoped=true&"
import script from "./ListMenuChat.vue?vue&type=script&lang=js&"
export * from "./ListMenuChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eab7e01",
  null
  
)

export default component.exports